import React from "react";
import { Box, Grid, Typography, Container } from "@mui/material";

export default function WhoIsThisFor() {
  const items = [
    {
      text: "Freshers looking for a career roadmap",
      icon: "/assets/images/career-roadmap.svg",
    },
    {
      text: "Founders & CEOs planning future skills",
      icon: "/assets/images/future-skills.svg",
    },
    {
      text: "Mid-career professionals seeking direction",
      icon: "/assets/images/seek-direction.svg",
    },
    {
      text: "Anyone wanting a clear career plan",
      icon: "/assets/images/career-plan.svg",
    },
  ];

  return (
    <Box
      sx={{
        backgroundColor: "#000",
        py: { xs: 6, md: 8, lg: 10 },
        px: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Container maxWidth="xl">
        {/* Section Title */}
        <Typography
          sx={{
            color: "#fff",
            fontFamily: "'SF Pro Display', 'Inter', sans-serif",
            fontWeight: 600,
            fontSize: { xs: "28px", sm: "36px", md: "56px" },
            lineHeight: { xs: "1.3", md: "70px" },
            textAlign: "center",
            mb: { xs: 4, md: 6, lg: 8 },
          }}
        >
          Who Is This For?
        </Typography>

        {/* Cards */}
        <Grid container spacing={{ xs: 3, md: 4 }} justifyContent="center">
          {items.map((item, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Box
                sx={{
                  background:
                    "linear-gradient(180deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.02) 100%)",
                  borderRadius: "20px",
                  height: { xs: "auto", md: "200px" },
                  maxWidth: { md: "719px" },
                  mx: "auto",
                  position: "relative",
                  px: { xs: 3, md: 6 },
                  py: { xs: 3, md: 4 },
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    background:
                      "linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.04) 100%)",
                  },
                }}
              >
                {/* Text */}
                <Typography
                  sx={{
                    color: "#fff",
                    fontFamily: "'SF Pro Display', 'Inter', sans-serif",
                    fontWeight: 400,
                    textAlign: "left",
                    fontSize: {
                      xs: "18px",
                      sm: "22px",
                      md: "30px",
                    },
                    lineHeight: {
                      xs: "26px",
                      sm: "32px",
                      md: "40px",
                    },
                    pr: { xs: "90px", md: "160px" }, // ensures space for 80px icon + padding
                  }}
                >
                  {item.text}
                </Typography>

                {/* Icon */}
                <Box
                  component="img"
                  src={item.icon}
                  alt="icon"
                  sx={{
                    position: "absolute",
                    right: { xs: 16, md: 32 },
                    top: "70%",
                    transform: "translateY(-50%)",
                    width: { xs: 60, md: 80 }, // fixed to 80px at desktop
                    height: { xs: 60, md: 80 },
                    objectFit: "contain",
                    pointerEvents: "none",
                  }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
